export default "__VITE_ASSET__Dt3fOfd5__"